export var SortEnum;
(function (SortEnum) {
    SortEnum["ASC"] = "asc";
    SortEnum["DESC"] = "desc";
})(SortEnum || (SortEnum = {}));
